var map = {
	"./arrow_bottom.svg": "0db1",
	"./behance.svg": "c85e",
	"./facebook.svg": "8485",
	"./github.svg": "14f6",
	"./instagram.svg": "bd6c",
	"./linkedin.svg": "9ed9",
	"./moon_off.svg": "01a4",
	"./moon_on.svg": "6427",
	"./sun_off.svg": "0e10",
	"./sun_on.svg": "d10f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";